import {useQuery} from "react-query";
import getPromise from "./getPromise";
import {ajax_url} from "../routes/ComplaintCategoryList_Route";

const prefix_url = "/complaint_category";

export const useComplaintCategoryList = ()=>{
    return useQuery(ajax_url, () => getPromise(prefix_url));
}
